function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5775",
  "data-name": "Group 5775",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5774",
  "data-name": "Group 5774"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9230",
  "data-name": "Path 9230",
  d: "M51.5,66.508A24.457,24.457,0,0,1,76,90.864a23.965,23.965,0,0,1-.256,3.182,180.976,180.976,0,0,1,33.065-3.035,195.259,195.259,0,0,1,30.352,2.408c-.059-.7-.154-1.4-.154-2.1a24.7,24.7,0,0,1,24.5-24.829,24.275,24.275,0,0,1,2.888.189,58.122,58.122,0,0,0,.613-7.939C167.015,26.351,140.321,0,107.507,0S48,26.351,48,58.741a58.335,58.335,0,0,0,.62,7.949A24.645,24.645,0,0,1,51.5,66.508Z",
  transform: "translate(-33.998)",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9231",
  "data-name": "Path 9231",
  d: "M39.638,246.077a17.26,17.26,0,0,0,.7-4.722,17.5,17.5,0,0,0-35,0c0,6.56,2.408,14.047,8.867,16.921,1.932-3.5,5.664-6.794,12.56-8.838Q33.236,247.516,39.638,246.077Z",
  transform: "translate(-5.334 -150.491)",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9232",
  "data-name": "Path 9232",
  d: "M161.887,306.315a191.823,191.823,0,0,0-53.074-7.649,178.379,178.379,0,0,0-51.4,7.649c-8.436,2.5-9.413,6.7-9.413,9.63v12.983c0,5.394,4.988,10.648,10.5,11.551v7.193a3.5,3.5,0,0,0,3.5,3.5h3.5a3.5,3.5,0,0,0,3.5-3.5v-7h77.01v7a3.5,3.5,0,0,0,3.5,3.5h3.5a3.5,3.5,0,0,0,3.5-3.5v-7h1.96c6.3,0,8.541-6.329,8.541-11.744V315.944C167.015,308.38,165.075,307.26,161.887,306.315Z",
  transform: "translate(-33.998 -200.654)",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9233",
  "data-name": "Path 9233",
  d: "M364.169,224a17.686,17.686,0,0,0-17.5,17.828,18.077,18.077,0,0,0,.35,3.346c6.8,1.33,12.731,2.846,17.5,4.264,5.328,1.582,7.876,4.652,9.1,8.334,5.079-2.748,8.051-8.436,8.051-15.945A17.686,17.686,0,0,0,364.169,224Z",
  transform: "translate(-234.653 -150.491)",
  fill: "#000"
})));

function SvgChairHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sofa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.018,
    height: 150.519,
    fill: "white",
    viewBox: "0 0 147.018 150.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairHome);
export default __webpack_public_path__ + "static/media/chair-home.587d4a3c.svg";
export { ForwardRef as ReactComponent };